// Foundations
import {Component, Input, OnInit} from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics.service';

// Models
import { HelloSignService } from '../../../services/hello-sign.service';

@Component({
  selector: 'app-camper-app-page',
  templateUrl: './camper-application-page.component.html',
  styleUrls: ['./camper-application-page.component.scss'],
})
export class CamperApplicationPageComponent implements OnInit {
  @Input() showText: true;

  constructor(
    public helloSignService: HelloSignService,
    private _analytics: AnalyticsService
  ) {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit() {
    this.helloSignService.fetchForms();
  }

  // get termPolicyFormCountry() {
  //   return (this.helloSignService.requiredTermPolicyForm.geoCountry.name === 'United States') ?
  //    'USA' : this.helloSignService.requiredTermPolicyForm.geoCountry.name;
  // }

  get termPolicyFormCountry() {
    return this.helloSignService.requiredTermPolicyForm.geoCountry.name;
  }

  get buttonText() {
    //
    if (this.helloSignService.signingCompleted) {
      return 'View Signed Release On File';
    } else if (this.helloSignService.inCheckingSigningStatus) {
      return 'Checking Signing Status...';
    } else {
      return 'Review + Sign';
    }
    // return this.helloSignService.signedTermPolicyForm
    //   ? 'View Signed Release On File'
    //   : 'Review + Sign';
  }

  handleButtonClick() {
    if (this.helloSignService.signedTermPolicyForm) {
      this._analytics.logButtonTap('myProfile_viewSignedDoc');

      this.helloSignService.getExistingSignature();
    } else {
      this._analytics.logButtonTap('myProfile_signNewDoc');

      this.helloSignService.createSignatureRequest();
    }
  }
}
